export default __webpack_public_path__ + "static/char-s-49-zh-Hans-586b216e75ced2a601e4b1eca8c3a6e3.png";